/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WaitlistEntry
 */
export interface WaitlistEntry {
    /**
     * 
     * @type {string}
     * @memberof WaitlistEntry
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WaitlistEntry
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof WaitlistEntry
     */
    position: number;
    /**
     * 
     * @type {number}
     * @memberof WaitlistEntry
     */
    waitlistedAt?: number;
}

/**
 * Check if a given object implements the WaitlistEntry interface.
 */
export function instanceOfWaitlistEntry(value: object): value is WaitlistEntry {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    return true;
}

export function WaitlistEntryFromJSON(json: any): WaitlistEntry {
    return WaitlistEntryFromJSONTyped(json, false);
}

export function WaitlistEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): WaitlistEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'position': json['position'],
        'waitlistedAt': json['waitlistedAt'] == null ? undefined : json['waitlistedAt'],
    };
}

export function WaitlistEntryToJSON(json: any): WaitlistEntry {
    return WaitlistEntryToJSONTyped(json, false);
}

export function WaitlistEntryToJSONTyped(value?: WaitlistEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'position': value['position'],
        'waitlistedAt': value['waitlistedAt'],
    };
}

